<template>
  <v-layout>
    <v-flex md3>
      <v-card>
        <v-card-title>
          <v-text-field
            outline
            :label="
              english ? 'Search Manifest Number' : 'Recherche d\'un manifeste'
            "
            append-icon="search"
            color="blue"
            class="mt-4"
            @click:append="searchForManifest()"
            :rules="[(v) => !!v || 'Manifest number is required']"
            v-model="manifestToSearch"
          >
          </v-text-field>

          <p v-if="searchFeedback" class="red--text">{{ searchFeedback }}</p>

          <v-layout v-if="searchResult">
            <v-flex md12>
              <v-layout align-center justify-center>
                <v-flex md6
                  ><v-btn
                    round
                    color="green"
                    class="white--text"
                    v-on:click="clearSearch()"
                    >Clear Search</v-btn
                  ></v-flex
                >
              </v-layout>
              <v-layout class="mt-4">
                <v-flex md12>
                  <v-card
                    v-for="(manifest, index) in searchResult"
                    :key="index"
                    style="border: 0.2em solid #4e84ae"
                    class="mb-2"
                    flat
                  >
                    <v-list two-line>
                      <v-list-tile v-on:click="getManifestPDF(manifest)">
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <v-layout color="primary">
                              <v-flex class="text-md-left"
                                >Manifest #
                                {{ manifest.manifest_number }}</v-flex
                              >
                              <v-flex class="text-md-right">{{
                                formatDate(manifest.manifest_date)
                              }}</v-flex>
                            </v-layout>
                          </v-list-tile-title>
                          <v-list-tile-sub-title
                            :class="{
                              'white--text darken-1':
                                findManifest(manifest) >= 0,
                            }"
                          >
                            <v-layout>
                              <v-flex class="text-md-left">{{
                                manifest.custname
                              }}</v-flex>
                              <v-flex class="text-md-right"
                                >{{ manifest.manifest_customer }}/{{
                                  manifest.manifest_location
                                }}</v-flex
                              >
                            </v-layout>
                            <v-layout>
                              <v-flex class="text-md-left">{{
                                manifest.plant
                              }}</v-flex>
                            </v-layout>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-list two-line>
            <v-list-group
              prepend-icon="fa-calendar-alt"
              v-for="(monthlyManifests, index) in manifestsByMonth"
              :key="index"
              :value="index == 0"
            >
              <template slot="activator">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title
                      >{{ monthlyManifests.month }}
                      {{ monthlyManifests.year }}</v-list-tile-title
                    >
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile v-if="monthlyManifests.manifestList.length < 1">
                <v-list-tile-content> Nothing Here </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                v-for="manifest in monthlyManifests.manifestList"
                :key="manifest.manifest_number"
                v-on:click="getManifestPDF(manifest)"
                :class="{ activeManifest: findManifest(manifest) >= 0 }"
                ripple
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-layout color="primary">
                      <v-flex class="text-md-left"
                        >Manifest # {{ manifest.manifest_number }}</v-flex
                      >
                      <v-flex class="text-md-right">{{
                        formatDate(manifest.manifest_date)
                      }}</v-flex>
                    </v-layout>
                  </v-list-tile-title>
                  <v-list-tile-sub-title
                    :class="{
                      'white--text darken-1': findManifest(manifest) >= 0,
                    }"
                  >
                    <v-layout>
                      <v-flex class="text-md-left">{{
                        manifest.custname
                      }}</v-flex>
                      <v-flex class="text-md-right"
                        >{{ manifest.manifest_customer }}/{{
                          manifest.manifest_location
                        }}</v-flex
                      >
                    </v-layout>
                    <v-layout>
                      <v-flex class="text-md-left">{{ manifest.plant }}</v-flex>
                    </v-layout>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-flex md9 style="background-color: teal">
      <p v-if="getCustNum === 'GRP'" class="white--text subheading pl-2">
        You are currently viewing as group, please choose a customer account to
        view manifests using the navigation bar above.
      </p>
      <v-tabs
        dark
        style="background-color: #4b4c58"
        slider-color="#FFFFFF"
        show-arrows
        v-if="manifestTabs.length > 0"
        v-model="tab"
      >
        <v-tab
          v-for="(manifest, index) in manifestTabs"
          :key="index"
          :href="'#' + prependManifest + manifest.manifestData.manifest_number"
        >
          Manifest #{{ manifest.manifestData.manifest_number }}
          <v-icon class="ml-2" color="red" @click="removeManifestTab(index)"
            >close</v-icon
          >
        </v-tab>

        <v-tabs-items>
          <v-tab-item
            v-for="(manifest, index) in manifestTabs"
            :key="index"
            :value="prependManifest + manifest.manifestData.manifest_number"
          >
            <v-card class="ma-2">
              <v-layout>
                <v-flex md12>
                  <object
                    :data="manifest.manifestPDF"
                    type="application/pdf"
                    width="100%"
                    style="height: 100vh"
                  ></object>
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      // manifestsByMonth: [],
      tab: null,
      manifestTabs: [],
      manifestPDF: null,
      manifestToSearch: "",
      searchResult: null,
      searchFeedback: "",
      prependManifest: "manifest-",
    };
  },
  methods: {
    ...mapActions(["LOAD_CUST_MANIFEST_DATA"]),
    addManifestTab(manifestData) {
      return this.manifestTabs.push({
        manifestData: manifestData,
        manifestPDF: null,
      });
    },
    removeManifestTab(closeIndex) {
      this.manifestTabs = this.manifestTabs.filter((manifest, index) => {
        return index != closeIndex;
      });
    },
    findManifest(manifestData) {
      return this.manifestTabs.findIndex((manifest) => {
        return (
          manifest.manifestData.manifest_number == manifestData.manifest_number
        );
      });
    },
    getManifestPDF(manifestData) {
      let found = this.findManifest(manifestData);

      if (found < 0) {
        let currIndex = this.addManifestTab(manifestData) - 1;
        let requestData = manifestData;
        //console.log(requestData)

        let baseURL = window.location.hostname;
        let baseProtocol = window.location.protocol;
        axios
          .post(
            `${baseProtocol}//${baseURL}/manifests_api/getManifestPDF`,
            requestData,
            { responseType: "blob" }
          )
          .then((res) => {
            if (res.data) {
              //console.log('Got the PDF!')
              const file = new Blob([res.data], { type: "application/pdf" });
              this.manifestTabs[currIndex].manifestPDF =
                URL.createObjectURL(file);

              this.tab = this.prependManifest + manifestData.manifest_number;
            } else {
              console.log("No data found");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    searchForManifest() {
      const manifestNumber = this.manifestToSearch;

      const requestData = {
        country: this.getUserCountry,
        customerNumber: this.getCustNum,
        manifestNumber,
      };
      //console.log(requestData)

      let baseURL = window.location.hostname;
      let baseProtocol = window.location.protocol;
      axios
        .post(
          `${baseProtocol}//${baseURL}/manifests_api/searchManifestByCustomer`,
          requestData
        )
        .then((res) => {
          if (res.data) {
            this.searchResult = res.data;

            if (typeof this.searchResult == "string") {
              this.searchFeedback = `No result found for ${manifestNumber}.`;
            } else {
              this.searchFeedback = "";
            }
          } else {
            console.log("No data found");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearSearch() {
      this.searchResult = null;
      this.manifestToSearch = null;
    },
    formatDate(manifest_date) {
      if (manifest_date) {
        return moment(manifest_date, "YYYY-MM-DD hh:mm:ss").format(
          "YYYY-MM-DD"
        );
      } else {
        return null;
      }
    },
  },
  computed: {
    ...mapState([
      "dateToManifest",
      "dateFromManifest",
      "manifestsByMonth",
      "english",
    ]),
    getUserCountry: function () {
      return this.$store.state.userCountry;
    },
    getCustNum: function () {
      return this.$store.state.cust;
    },
    /*
        getMonthFromManifest: function()
        {
            return moment(this.selectedManifest.manifest_date).format('MMMM')
        },
        getYearFromManifest: function()
        {
            return moment(this.selectedManifest.manifest_date).format('YYYY')
        },
        getDateFromManifest: function()
        {
            return moment(this.selectedManifest.created_date, 'YYYY-MM-DDTHH:mm:SSSZ').format('YYYY-MM-DD HH:mm:ss')
        }
        */
  },
  mounted() {
    this.LOAD_CUST_MANIFEST_DATA();
  },
};
</script>

<style>
.activeManifest {
  background-color: #00807a;
  color: #ffffff;
  margin: 0.15em;
}
</style>
